import { DomainService } from "./DomainService";

const baseUrl = DomainService.GetBaseUrl() + "airaa/";
const apiKey = import.meta.env.VITE_API_KEY;

const TrackCertificateStatus = async (payload) => {
  try {
    const res = await fetch(baseUrl + "track-certificate-status", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${apiKey}`
      },
      body: JSON.stringify(payload)
    });
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error tracking certificate status:", error);
    throw error;
  }
};

const ApproveCertificate = async (payload) => {
  try {
    const res = await fetch(baseUrl + "approve-rejection-certificate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${apiKey}`
      },
      body: JSON.stringify(payload)
    });
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error approving certificate:", error);
    throw error;
  }
};



export const CertificateApprovalService = {
  TrackCertificateStatus,
  ApproveCertificate,
};